import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./HistoryChatContainer.module.scss";
import { MoonLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import { getAssistantById } from "../../utils/api/actions/assistant";
import { getDialog } from "../../utils/api/actions/dialogs";

export default function HistoryChatContainer({ dialogs, assistants }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const activeDialog = useSelector((state) => state.dialog.activeDialog);
  const activeAssistant = useSelector(
    (state) => state.assistant.activeAssistant
  );
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );
  const isLoadingDialog = useSelector((state) => state.dialog.isLoadingDialog);
  const isLoadingAssistant = useSelector(
    (state) => state.assistant.isLoadingAssistant
  );

  const handlerGetDialogId = (e) => {
    dispatch(getDialog(e.target.id));
  };

  const handlerGetAssistantId = (e) => {
    if (updateAssistant) return;
    assistants.map((el) => {
      if (el.id === e.target.id) {
        dispatch(getAssistantById(el.id));
      }
      return null;
    });
  };

  const renderTitle = () => {
    if (location.pathname === "/dialog" || dialogs) return "История чатов";
    if (location.pathname === "/assistants" || assistants) return "Ассистенты";
    return "";
  };

  const isLoading =
    location.pathname === "/dialog" ? isLoadingDialog : isLoadingAssistant;
  const dataList = location.pathname === "/dialog" ? dialogs : assistants;

  const renderItem = () => {
    if (isLoading) {
      return (
        <div style={{ marginTop: 10, marginLeft: 50 }}>
          <MoonLoader size={30} color="#3e8fcb" />
        </div>
      );
    }

    if (!dataList || dataList.length === 0) {
      return <div>Нет данных</div>;
    }

    return (
      <div className={styles.dialogs}>
        {dataList.map((el) => (
          <span
            key={el.id}
            className={`${styles.dialogName} ${
              activeDialog?.id === el.id ? styles.activeDialog : ""
            } ${activeAssistant?.id === el.id ? styles.activeDialog : ""}`}
            onClick={
              location.pathname === "/dialog"
                ? handlerGetDialogId
                : handlerGetAssistantId
            }
            id={el.id}
          >
            {el.name}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.line}></div>
        <span className={styles.title}>{renderTitle()}</span>
        <div className={styles.line}></div>
      </div>

      {/* {`----- ${renderTitle()} ---------`}</span> */}

      {renderItem(
        dialogs?.length ? dialogs : assistants?.length ? assistants : []
      )}
    </div>
  );
}
